import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import { Toaster } from "./ui/sonner";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="App flex min-h-screen flex-col bg-white">
      <Navigation />
      <main data-testid="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      <Toaster position="top-center" richColors />
    </div>
  );
}
